import { hotjar } from "react-hotjar";
import { Fragment } from "react";
import { AuthService } from "@adfenix/types";

interface HotjarProps {
  userData: AuthService.UserDataForIntercomResponse | undefined;
}

const HotjarId = parseInt(process.env.REACT_APP_HOTJAR_ID ?? "-1");
const HotjarSnippetVersion = parseInt(
  process.env.REACT_APP_HOTJAR_SNIPPET_VERSION ?? "-1"
);
const Hotjar = ({ userData }: HotjarProps) => {
  if (!hotjar.initialized() && HotjarId > 0 && HotjarSnippetVersion > 0) {
    hotjar.initialize(HotjarId, HotjarSnippetVersion);
  }

  if (userData && hotjar.initialized())
    hotjar.identify(userData.userId, {
      email: userData.email,
      name: userData.name,
      loggedInBefore: userData.loggedInBefore,
      role: userData.roleName,
      hqId: userData.hq.hqId,
      hqName: userData.hq.hqName
    });
  return <Fragment />;
};

export default Hotjar;
